exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-validate-field label,.form-validate-field button{\n    vertical-align: top;\n}\n.form-validate-field label{\n    padding:7px;\n}\n.form-validate-field .field-with-validation{\n    display: inline-block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/leads/assign-opener/lead-assign-opener.component.css
// module id = 1219
// module chunks = 9